import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Header } from "../components/shared";
import { CheckoutFooter } from "../components/checkout";
import { useTranslation } from "../hooks/useTranslation";
import { trackPurchase } from "../services/analyticsService";
import "../styles/checkout/CheckoutSuccess.css";

const CheckoutSuccess = () => {
  const { t, getLocalizedPath } = useTranslation('checkout');
  const [searchParams] = useSearchParams();
  const [sessionId] = useState(searchParams.get('session_id'));

  useEffect(() => {
    // Track purchase in GA4 before clearing data
    try {
      const bookingData = JSON.parse(sessionStorage.getItem("bookingData") || "{}");
      const step2Data = JSON.parse(sessionStorage.getItem("checkoutStep2Data") || "{}");
      if (bookingData.vehicleId) {
        trackPurchase({
          ...bookingData,
          orderId: sessionId,
          insurance: step2Data?.selectedPlan,
        });
      }
    } catch (err) {
      console.warn('GA4 purchase tracking failed:', err);
    }

    // Clear checkout data from sessionStorage after successful payment
    sessionStorage.removeItem("checkoutStep1Data");
    sessionStorage.removeItem("checkoutStep2Data");
    sessionStorage.removeItem("checkoutStep3Data");
    sessionStorage.removeItem("bookingData");
    sessionStorage.removeItem("cartSessionId");
  }, [sessionId]);

  return (
    <div className="checkout-success-container">
      <Header />
      
      <div className="success-main-content">
        <div className="success-content">
          <div className="success-icon">
            <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
              <circle cx="40" cy="40" r="40" fill="#009B31" />
              <path
                d="M25 40L35 50L55 30"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          
          <h1 className="success-title">{t('success.title')}</h1>

          <p className="success-description">
            {t('success.description')}
          </p>

          {sessionId && (
            <div className="session-info">
              <p className="session-id">
                <strong>{t('success.paymentId')}</strong> {sessionId}
              </p>
            </div>
          )}

          <div className="success-actions">
            <button
              className="back-home-button"
              onClick={() => window.location.href = getLocalizedPath('/')}
            >
              {t('success.backToHome')}
            </button>
          </div>

          <div className="next-steps">
            <h3>{t('success.nextSteps.title')}</h3>
            <ul>
              <li>{t('success.nextSteps.step1')}</li>
              <li>{t('success.nextSteps.step2')}</li>
              <li>{t('success.nextSteps.step3')}</li>
              <li>{t('success.nextSteps.step4')}</li>
            </ul>
          </div>
        </div>
      </div>
      
      <CheckoutFooter />
    </div>
  );
};

export default CheckoutSuccess;